import { Columns3 } from "lucide-react";
import { Button } from "@/shared/components/ui/button";
import {
	DropdownMenu,
	DropdownMenuCheckboxItem,
	DropdownMenuContent,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@/shared/components/ui/dropdown-menu";
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from "@/shared/components/ui/tooltip";
import { useColumnPicker } from "./ColumnPickerContext";
import styles from "./HeaderBar.module.css";

export function ColumnPickerButton() {
	const handle = useColumnPicker();
	if (!handle || handle.columns.length === 0) return null;

	const hasHidden = handle.columns.some(
		(c) => handle.visibility[c.id] === false,
	);

	return (
		<DropdownMenu>
			<Tooltip>
				<TooltipTrigger asChild>
					<DropdownMenuTrigger asChild>
						<Button
							variant="outline"
							size="icon"
							className={`${styles.actionButtonIcon} border-border text-foreground bg-card hover:bg-secondary relative`}
						>
							<Columns3 className="h-4 w-4" />
							{hasHidden && (
								<span className="absolute -top-1 -right-1 h-2.5 w-2.5 rounded-full bg-blue-500 border-2 border-card" />
							)}
						</Button>
					</DropdownMenuTrigger>
				</TooltipTrigger>
				<TooltipContent>
					<p>Show/hide columns</p>
				</TooltipContent>
			</Tooltip>
			<DropdownMenuContent align="start" className="w-48">
				<DropdownMenuLabel>Columns</DropdownMenuLabel>
				<DropdownMenuSeparator />
				{handle.columns.map((col) => (
					<DropdownMenuCheckboxItem
						key={col.id}
						checked={handle.visibility[col.id] !== false}
						onCheckedChange={() => handle.onToggle(col.id)}
						onSelect={(e) => e.preventDefault()}
						className="capitalize"
					>
						{col.label}
					</DropdownMenuCheckboxItem>
				))}
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
